<div class="spinner-container" *ngIf="loading">
    <mat-spinner class="content-box"></mat-spinner>
</div>

<!-- Filter -->
<div autofocus class="filter-container">
    <mat-form-field>
        <mat-select placeholder="{{'consentsTexts.status' | translate}}" [(ngModel)]="options.status"
            (selectionChange)="filterByStatus()">
            <mat-option *ngFor="let status of consentStatusEnum | enumToArray" [value]="status">
                {{ statusText(status) | translate }}
            </mat-option>
        </mat-select>
    </mat-form-field>
</div>

<!-- No data found-->
<div class="message" *ngIf="!hasData() && !loading">
    {{'consentsTexts.noConsentsFound' | translate}}
</div>

<div class="data-container" [hidden]="!hasData()">
    <div class="mat-elevation-z8 table-content">
        <mat-table mat-table [dataSource]="dataSource">

            <!-- Status-->
            <ng-container matColumnDef="status">
                <mat-header-cell mat-header-cell *matHeaderCellDef> {{'consentsTexts.status' | translate}}
                </mat-header-cell>
                <mat-cell mat-cell *matCellDef="let element" matTooltip="{{statusIcon(element)?.tooltip | translate}}">
                    <cqes-icon [icon]="statusIcon(element)?.icon" [iconClass]="statusIcon(element)?.colorClass">
                    </cqes-icon>
                </mat-cell>
            </ng-container>

            <!-- Created Date-->
            <ng-container matColumnDef="createdDate">
                <mat-header-cell mat-header-cell *matHeaderCellDef>
                    {{'consentsTexts.createdDate' | translate}}
                </mat-header-cell>
                <mat-cell mat-cell *matCellDef="let element">
                    {{element.createdDate | date: 'dd.MM.yyyy'}}</mat-cell>
            </ng-container>

            <!-- Expiration Date-->
            <ng-container matColumnDef="expirationDate">
                <mat-header-cell mat-header-cell *matHeaderCellDef>
                    {{'consentsTexts.expirationDate' | translate}}
                </mat-header-cell>
                <mat-cell mat-cell *matCellDef="let element">
                    <span >{{element.expirationDate | date: 'dd.MM.yyyy'}}</span>
                </mat-cell>
            </ng-container>

            <!-- Organisation Name -->
            <ng-container matColumnDef="orgName">
                <mat-header-cell mat-header-cell *matHeaderCellDef> {{'consentsTexts.orgName' | translate}}
                </mat-header-cell>
                <mat-cell mat-cell *matCellDef="let element"> {{element.orgName}} </mat-cell>
            </ng-container>

            <!-- Role Name -->
            <ng-container matColumnDef="roleName">
                <mat-header-cell mat-header-cell *matHeaderCellDef> {{'consentsTexts.roleName' | translate}}
                </mat-header-cell>
                <mat-cell mat-cell *matCellDef="let element"> {{element.roleName}} </mat-cell>
            </ng-container>

            <!-- Actions -->
            <ng-container matColumnDef="actions" class="tar">
                <mat-header-cell #actions *matHeaderCellDef>
                    {{'consentsTexts.actions'| translate}}
                </mat-header-cell>
                <mat-cell class="d-sm-flex" *matCellDef="let row">
                    <div *ngIf="isActivated(row)">
                        <span [matMenuTriggerFor]="actionsMenu">
                            <button mat-icon-button color="primary">
                                <cqes-icon icon="menu"></cqes-icon>
                            </button>
                        </span>
                        <mat-menu #actionsMenu [overlapTrigger]="false" class="nav-responsive-overlay">
                            <button mat-menu-item *ngIf="isActive(row)" color="primary"
                                matTooltip="{{'consentsTexts.revoke' | translate}}" (click)="revokeConsent(row)">
                                <cqes-icon icon="pan_tool"></cqes-icon>
                                {{'consentsTexts.revoke' | translate}}
                            </button>

                            <button mat-menu-item *ngIf="isActivated(row)" color="primary"
                                matTooltip="{{'consentsTexts.download' | translate}}" (click)="downloadConsent(row)">
                                <cqes-icon icon="file_download"></cqes-icon>
                                {{'consentsTexts.download' | translate}}
                            </button>
                        </mat-menu>
                    </div>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>
        <mat-paginator [pageSize]="tableHelper.pageSize" [pageSizeOptions]="tableHelper.pageSizeOptions"
            (page)="onPaginateChange($event)" showFirstLastButtons></mat-paginator>
    </div>
</div>